import React from "react";
import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import { setStatus } from "../../actions/messageActions";
import {
  deleteProduct,
  setProductStatus,
  viewCustomerOrder,
} from "../../actions/storeActions";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { toast } from "react-toastify";

import { SocketData } from "../../context/SocketContext";
const DashboardDetails = ({
  indexOfFirstArticle,
  indexOfLastArticle,
  tableData,
  setTableData,
  actions,
  points,
  category,
  discount,
  deletable,
  editable,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.adminDetail);
  const { socket } = SocketData();

  const table_data = useSelector((state) => state.messageDetail);

  const handleEditProduct = (data, idx) => {
    dispatch({
      type: "OPEN_EDIT_PRODUCT_MODAL",
      payload: { open: true, data: data, idx },
    });
  };

  const handleGetOrder = async (orderId, userId) => {
    const data = {
      orderId,
      userId,
    };
    const orderData = await viewCustomerOrder(data);

    dispatch({
      type: "VIEW_OPEN_REQUEST_MODAL",
      payload: { data: orderData, request_modal_open: true },
    });
  };
  const handleDeleteProduct = async (id, category) => {
    dispatch({ type: "DELETE_PRODUCT", payload: { id, category } });
    const response = await deleteProduct({ data: { id, category } });
    if (response.param === "success") {
      alertify.set("notifier", "position", "bottom-right");
      alertify.success(`${response.msg}`);
    }
  };
  const handleChangeStatus = async (
    e,
    id,
    name,
    userId,
    orderId,
    totalPrice,
    status
  ) => {
    const statusTypesMessages = {
      Pending: `Your order ${orderId} is on the move for delivery. Please Prepare the exact amount of ₱${totalPrice}. Thank you`,
      Read: `Your order ${orderId} is received and on process for delivery.`,
      Completed: `Order ${orderId} is successfully delivered. Thank you for ordering ${name}.`,
      Rejected: `Sorry we cannot process your order ${orderId}. Please make a direct contact to the admin.`,
    };
    dispatch({
      type: "CHANGE_DASHBOARD_STATUS",
      payload: { prev: status.prevStatus, updated: e.target.value },
    });
    tableData.forEach((data, idx) => {
      const { _id } = data;

      if (_id === id) {
        tableData[idx].status = e.target.value;
        if (category === "dish") {
          dispatch({
            type: "CHANGE_STATUS",
            payload: { ...table_data.table_data, dish: [...tableData] },
          });
          // setTableData({ ...table_data.table_data, dish: [...tableData] });
        } else if (category === "requests") {
          dispatch({
            type: "CHANGE_STATUS",
            payload: { ...table_data.table_data, message: [...tableData] },
          });

          // setTableData({ ...table_data.table_data, message: [...tableData] });
        } else if (category === "goods") {
          dispatch({
            type: "CHANGE_STATUS",
            payload: { ...table_data.table_data, goods: [...tableData] },
          });

          // setTableData({ ...table_data.table_data, goods: [...tableData] });
        }
      }
    });
    await setStatus({ id, status: e.target.value, userId });
    await setProductStatus({ id, status: e.target.value });
    socket.current.emit("sendMessage", {
      senderId: user.userId,
      receiverId: userId,
      text:
        e.target.value === "Read"
          ? statusTypesMessages.Read
          : e.target.value === "Pending"
          ? statusTypesMessages.Pending
          : e.target.value === "Completed"
          ? statusTypesMessages.Completed
          : e.target.value === "Rejected" && statusTypesMessages.Rejected,
    });
  };

  return (
    <>
      {tableData
        .slice(indexOfFirstArticle, indexOfLastArticle)
        .map((data, idx) => {
          const {
            _id,
            message,
            fullName,
            email,
            status,
            userId,

            price,
            name,
            totalPrice,
            orderId,
            serviceType,
            discount,
            points,
            createdAt,
            pieces,

            category,
          } = data;
          return (
            <tr className="each-request-list" key={_id}>
              {(message || pieces) && <td>{message ? message : pieces}</td>}
              <td>{fullName ? fullName : name}</td>
              <td className="email-container">
                {email ? (
                  email
                ) : price ? (
                  `₱${price}`
                ) : (
                  <span
                    style={{ textDecoration: "underline", color: "blue" }}
                    onClick={() => {
                      handleGetOrder(orderId, userId);
                    }}
                  >
                    View Order
                  </span>
                )}
              </td>
              {(points >= 0 || totalPrice) && (
                <td className="email-container">
                  {points ? points : totalPrice}
                </td>
              )}
              {serviceType && <td>{serviceType}</td>}
              <td>
                <span className={`indicator ${pieces <= 0 ? "Out" : status}`} />
                {pieces <= 0 ? "Out of stock" : status ? status : "NO"}
              </td>
              {discount ? (
                <td>{`${discount}%`}</td>
              ) : (
                <td> {moment(createdAt).format("L")}</td>
              )}

              <td className="action-container">
                <select
                  name="actions"
                  id="actions"
                  disabled={pieces <= 0}
                  onChange={(e) =>
                    handleChangeStatus(
                      e,
                      _id,
                      name,
                      userId,
                      orderId,
                      totalPrice,
                      {
                        prevStatus: status,
                      }
                    )
                  }
                >
                  <option>Actions</option>
                  {actions.map((action, idx) => {
                    return (
                      <option key={action} value={`${action}`}>
                        {action}
                      </option>
                    );
                  })}
                </select>
              </td>
              {editable && (
                <td>
                  {" "}
                  <button
                    className="edit_btn"
                    onClick={() => handleEditProduct(data, idx)}
                  >
                    <AiFillEdit />
                  </button>{" "}
                </td>
              )}
              {deletable && (
                <td>
                  {" "}
                  <button
                    className="delete_btn"
                    onClick={() => handleDeleteProduct(_id, category)}
                  >
                    <AiFillDelete />
                  </button>
                </td>
              )}
            </tr>
          );
        })}
    </>
  );
};

export default DashboardDetails;
